/** @file One animation in the list: open in the timeline, rename, length, duplicate, delete. */
import type { CommandCall } from '@pose2d/format/types';
import type { Translate } from '@pose2d/i18n/types';
import { Button } from '../../ui-kit/Button';
import { NumberField } from '../../ui-kit/NumberField';
import { TextInput } from '../../ui-kit/TextInput';
import { animationCalls } from './animationCalls';
import type { AnimationRowData } from './animationRows';

/** Props of AnimationRow; `copy` is the name a duplicate gets, `onOpen` / `onRemove` also move the playhead. */
export interface AnimationRowProps {
  row: AnimationRowData;
  current: boolean;
  copy: string;
  t: Translate;
  send: (call: CommandCall) => void;
  onOpen: () => void;
  onRemove: () => void;
}

/** The open (current) animation is highlighted. */
export function AnimationRow({ row, current, copy, t, send, onOpen, onRemove }: AnimationRowProps) {
  return (
    <li className={current ? 'animations-row animations-row-current' : 'animations-row'}>
      <button type="button" className="animations-open" aria-label={t('panels.animations.open', { name: row.name })} aria-pressed={current} onClick={onOpen}>
        ▶
      </button>
      <TextInput value={row.name} label={t('panels.animations.rename', { name: row.name })} onCommit={(name) => { send(animationCalls.rename(row.id, name)); }} />
      <NumberField value={row.frames} label={t('panels.animations.frames')} min={1} step={1} precision={0} onCommit={(frames) => { send(animationCalls.setFrames(row.id, frames)); }} />
      <Button label={t('panels.animations.duplicate')} onClick={() => { send(animationCalls.duplicate(row.id, copy)); }} />
      <Button label={t('panels.animations.remove')} danger onClick={onRemove} />
    </li>
  );
}
